const currentEnvMode = { value: void 0 };
function getEnvMode(envMode) {
  const innerEnvMode = envMode || currentEnvMode.value;
  if (!innerEnvMode)
    throw new Error("\u8BF7\u4F20\u5165envMode\u6216\u8C03\u7528initSelfAxios\u521D\u59CB\u5316envMode");
  return innerEnvMode;
}
export { currentEnvMode, getEnvMode };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/currentEnvMode.js